import { FC } from 'react';
import IconProps from './IconProps';
import VectorIcon from './VectorIcon';

const ProfileIcon: FC<IconProps> = ({ width = 57, height = 57 }) => {
  return (
    <VectorIcon width={width} height={height} fill="none">
      <circle
        cx="28.4502"
        cy="28.1143"
        r="26"
        fill="#0D2E68"
        stroke="url(#paint0_linear_4199_6796)"
        strokeWidth="4"
      />
      <path
        d="M31.4502 29.1143C37.5127 29.1143 42.4502 34.0518 42.4502 40.1143C42.4502 41.2393 41.5127 42.1143 40.4502 42.1143H16.4502C15.3252 42.1143 14.4502 41.2393 14.4502 40.1143C14.4502 34.0518 19.3252 29.1143 25.4502 29.1143H31.4502ZM17.4502 39.1143H39.3877C38.8877 35.1768 35.5127 32.1143 31.4502 32.1143H25.4502C21.3252 32.1143 17.9502 35.1768 17.4502 39.1143ZM28.4502 26.1143C24.0127 26.1143 20.4502 22.5518 20.4502 18.1143C20.4502 13.7393 24.0127 10.1143 28.4502 10.1143C32.8252 10.1143 36.4502 13.7393 36.4502 18.1143C36.4502 22.5518 32.8252 26.1143 28.4502 26.1143ZM28.4502 13.1143C25.6377 13.1143 23.4502 15.3643 23.4502 18.1143C23.4502 20.9268 25.6377 23.1143 28.4502 23.1143C31.2002 23.1143 33.4502 20.9268 33.4502 18.1143C33.4502 15.3643 31.2002 13.1143 28.4502 13.1143Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4199_6796"
          x1="28.4502"
          y1="4.11426"
          x2="28.4502"
          y2="52.1143"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00C2FF" />
          <stop offset="1" stopColor="#CEE8FF" />
        </linearGradient>
      </defs>
    </VectorIcon>
  );
};

export default ProfileIcon;
